import { Component, Input, OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-active-park-confirmation',
  templateUrl: './active-park-confirmation.component.html',
  styleUrls: ['./active-park-confirmation.component.scss'],
})
export class ActiveParkConfirmationComponent implements OnInit {

  @Input() isParkActive: any;

  confirmAction = new EventEmitter<string>();
  cancelAction = new EventEmitter<string>();

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
  ) {
  }

  ngOnInit(): void { }

  submitData() {
    const dataToSendBack = 'Modal Confirm';
    this.confirmAction.emit('Confirmed');
    this.modal.close(dataToSendBack);
  }

  cancelData() {
    const dataToSendBack = 'Modal Cancel';
    this.cancelAction.emit('Cancelled');
    this.modal.dismiss(dataToSendBack);
  }
}
